export const STATES = {
  STATUS: {
    SUCCESS: 0,
    WAITING: 100,
    UNAUTHORIZE: 401,
  },
}

export const ALERT = {
  LOW: 'success',
  HIGH: 'danger',
  MEDIUM: 'warning',
}

export const TASK = {
  COMPLETE_AND_CREATE_NEXT: 1,
  CONTINUE_AND_CREATE_NEXT: 2,
  CONTINUE: 3,
  COMPLETE: 4,
  EMPTY: 0,
  COMPLETE_TITLE: 8,
};

export const STAGE = {
  EMPTY_STATE: 0,
  INCOMPLETE_STATE: 1,
  ACTUAL: 3,
  COMPLETE_STATE: 2,
  TITLE: 100,
  PAYMENT: 101,
  NEGOTIATION: 102,
  CONCESSION: 103,
};

export const DOCUMENT = {
  CATASTRO: {
    ABARCAMIENTO: {
      NAME: 'Abarcamiento',
      NUMBER: 4,
    },
    OPOSICION: {
      NAME: 'Oposición',
      NUMBER: 2,
    },
    SUPERPOSICION: {
      NAME: 'Superposición',
      NUMBER: 3,
    },
    ENLARGMENT: {
      NAME: 'Ampliación del área solicitada',
      NUMBER: 6,
    },
    REDUCTION: {
      NAME: 'Reducción del área solicitada',
      NUMBER: 7,
    },
    EMPTY: {
      NAME: 'En Espera',
      NUMBER: 0,
    },
    UPLOADED: {
      NAME: 'Cargado',
      NUMBER: 1,
    },
    UPDATE: {
      NAME: 'Actualización',
      NUMBER: 5,
    },
  },
  COLOR: {
    RED: 'red',
    YELLOW: 'yellow',
    GREEN: 'green',
  },
  SUCCESS: 'success',
  ERROR: 'danger',
  SENDING: 'warning',
  PROGRESS: {
    OK: 100,
    ERROR: 100,
    SENDING: 10,
    EMPTY: 0,
  },
  DESCRIPTION: {
    FIRST: 'Se ha superpuesto un pedimento.',
    SECOND: 'Se ha superpuesto una manifestación.',
    THIRD: 'Se ha superpuesto una solicitud de mensura.',
    FOURTH: 'Se ha superpuesto una concesión de exploración.',
    FIFTH: 'Se ha producido un abarcamiento por otra mensura.',
    SIX: 'Actualización',
    SEVEN: 'Se ha ampliado por nuevos propietarios.',
    EIGHT: 'Se redujo por cambio de propietario.',
    NINE: 'Se ha ampliado el proyecto.',
    TEN: 'Se redujo el proyecto.',
    ELEVEN: 'Se modificó el trazado del proyecto.',
    TWELVE: 'Se ha actualizado.',
  },
}

export const PROJECT = {
  NOT_COMPLETE: 0,
  COMPLETE: 1,
}
